import { render, staticRenderFns } from "./IdentifierViewer.vue?vue&type=template&id=d9e746d0&scoped=true&"
import script from "./IdentifierViewer.vue?vue&type=script&lang=ts&"
export * from "./IdentifierViewer.vue?vue&type=script&lang=ts&"
import style0 from "./IdentifierViewer.vue?vue&type=style&index=0&id=d9e746d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9e746d0",
  null
  
)

export default component.exports